import React from 'react'
import OrdersContainer from 'containers/panel/subreseller/orders-container'

const OrdersPage = () => {
  return (
    <OrdersContainer/>
  )
}

export default OrdersPage